module.exports = __webpack_public_path__ + "static/media/jhon_and_george_thumb_even.fae5aa7f.jpg";